import { PackageOpen } from 'lucide-react';
import { imsGet } from '../../api/api';
import LiveDashboardPage from './LiveDashboardPage';

export default function IMSDashboardPage() {
  return <LiveDashboardPage title="IMS" description="Inventory Management System" icon={PackageOpen} getData={imsGet} />;
}